import {
    DataLabelOptions,
    DonutWidth,
    InnerRadius,
    LegendOptions,
    MetricGroupOptions,
    NumberFormat,
} from '@sprinklr/stories/hyperspaceWidgets/types';
import merge from 'lodash/merge';
import { observable } from 'mobx';
import { WidgetOptionsImpl } from 'models/Widget/WidgetOptions';
import { LegendOptionsImpl } from '../options';

import { HyperSpacePieChartWidgetOptions } from './types';

export class HyperSpacePieChartWidgetOptionsImpl extends WidgetOptionsImpl
    implements HyperSpacePieChartWidgetOptions {
    @observable legend: LegendOptions = merge(new LegendOptionsImpl(), {
        position: {
            selectedPosition: 'right',
        },
        maxWidth: 400,
    });

    @observable innerRadius: InnerRadius = {
        enabled: false,
        size: null,
    };
    @observable donutWidth: DonutWidth = {
        enabled: false,
        size: null,
    };
    @observable dataLabelOptions: DataLabelOptions = {
        enabled: false,
        formats: {
            numberFormat: {
                decimals: 2,
                useShortened: true,
            },
        },
        fontSize: 10,
    };
    @observable metricGroupOptions: MetricGroupOptions = {
        enabled: true,
        metric: {
            size: 50,
            enabled: true,
            format: {
                decimals: 2,
                useShortened: true,
            },
        },
        metricName: {
            size: 25,
            enabled: true,
        },
        percentChange: {
            size: 20,
            enabled: false,
        },
    };
    @observable metaInfoOptions: HyperSpacePieChartWidgetOptions['metaInfoOptions'] = {
        color: {
            enabled: false,
            type: 'fill',
        },
    };
}
